import React from "react"
import {Box} from "@mui/material";

const TreeInfoEditView = (props) => {

    return (
        <Box>編集画面</Box>
    )
}

export default TreeInfoEditView
